import { OwnerModel } from 'src/app/model/ownerModel.model';
import { ParcelModel } from 'src/app/model/parcelModel.model';
import { AddressModel } from '../../shared/model/addressModel.model';
import { ApoQueryable } from '../models/apoRecord.model';
import { APOSearchData } from '../models/APOSearchResult.model';
import { getApoDescriptor } from './apo.util';

export const getConditionTooltip = (data: ApoQueryable): string => `<div>
        <span>${$localize`There is a `}${data.hightestCondition.impactCode} on ${getApoDescriptor(data)}
            as of ${data.hightestCondition.issuedDate}</span>
        <span>${data.hightestCondition.conditionStatus}</span>
        <span>${data.hightestCondition.conditionComment}</span>
    </div>`;

export const getConditionTooltipFromSearchData = (data: APOSearchData): string => `<div>
    <span>${$localize`There is a `}${data.HighestCondition.impactCode} on ${data.Name}
        as of ${data.HighestCondition.issuedDate}</span>
    <span>${data.HighestCondition.conditionStatus}</span>
    <span>${data.HighestCondition.conditionComment}</span>
    </div>`;
